export const buttonClasses =
  "font-medium rounded-lg bg-default-600 text-white px-4 py-2 rounded flex items-center space-x-1 hover:bg-default-700";
